/**
 * English source aggregate — the single source of truth and i18next fallback.
 * `core` holds the app-shell/account/home keys; every other import is a
 * per-surface namespace owned by one area (see AGENTS.md). Each namespace lives
 * in its own file so surfaces can be translated independently without conflicts.
 */
import core from './en/core';
import simopsRoutes from './en/simopsRoutes';
import simopsShared from './en/simopsShared';
import simopsAnalysis from './en/simopsAnalysis';
import simopsDesignPoints from './en/simopsDesignPoints';
import simopsDraft from './en/simopsDraft';
import simopsFiles from './en/simopsFiles';
import simopsMeshing from './en/simopsMeshing';
import simopsReport from './en/simopsReport';
import simopsSolver from './en/simopsSolver';
import simopsMisc from './en/simopsMisc';
import simopsNew from './en/simopsNew';
import meshgen from './en/meshgen';
import diagnosisRoutes from './en/diagnosisRoutes';
import diagnosisComponents from './en/diagnosisComponents';
import auth from './en/auth';
import compCommon from './en/compCommon';
import compMesh from './en/compMesh';
import compAssistant from './en/compAssistant';
import compProductLibrary from './en/compProductLibrary';
import compMisc from './en/compMisc';
import commands from './en/commands';
import cadmorph from './en/cadmorph';

const en = {
  ...core,
  simopsRoutes,
  simopsShared,
  simopsAnalysis,
  simopsDesignPoints,
  simopsDraft,
  simopsFiles,
  simopsMeshing,
  simopsReport,
  simopsSolver,
  simopsMisc,
  simopsNew,
  meshgen,
  diagnosisRoutes,
  diagnosisComponents,
  auth,
  compCommon,
  compMesh,
  compAssistant,
  compProductLibrary,
  compMisc,
  commands,
  cadmorph,
};

export default en;
